var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58333 7.66671H5.41667C4.45977 7.66634 3.52097 7.92754 2.70176 8.42207C1.88255 8.9166 1.2141 9.62564 0.768667 10.4725C0.756147 10.3154 0.74992 10.1577 0.750001 10C0.750001 6.77829 3.36158 4.16671 6.58333 4.16671V0.958374L12.7083 5.91671L6.58333 10.875V7.66671ZM5.41667 6.50004H7.75V8.42971L10.8539 5.91671L7.75 3.40371V5.33337H6.58333C5.91265 5.33262 5.24971 5.47677 4.63989 5.75595C4.03008 6.03514 3.48777 6.44277 3.05008 6.95096C3.80335 6.65242 4.6064 6.49941 5.41667 6.50004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowShare);
export default __webpack_public_path__ + "static/media/arrow-share.0a393adf5132e6b16a8c04db2301e726.svg";
export { ForwardRef as ReactComponent };